import React, { useEffect } from 'react'
import { Col, Dropdown, Layout, Row, Space, Tooltip } from 'antd'
import LogoIcon from '@/assets/icons/logo'
import FlagIcon from '@/assets/icons/redflag.png'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import LandingImg1 from '@/assets/images/Landing_page_img1.svg'
import LandingImg2 from '@/assets/images/Landing_page_img2.svg'
import LandingImg3 from '@/assets/images/Landing_page_img3.svg'
import LandingLogo1 from '@/assets/images/Landing_page_logo1.svg'
import LandingLogo2 from '@/assets/images/Landing_page_logo2.svg'
import LandingLogo3 from '@/assets/images/Landing_page_logo3.svg'
import Footer from '@/layouts/footer'
import { Helmet } from 'react-helmet'
import './home.less'
import { MenuOutlined } from '@ant-design/icons'
import logo from '@/assets/images/Creole.png'

const Home = () => {
  const auth = useSelector((state) => state.auth)

  // const items = [
  // {
  //   label: (
  //     <a
  //       style={{ fontSize: 24 }}
  //       href="https://applyin.notion.site/ApplyIn-Blog-57900fa258ab40cd8e8fcec3994efc09?pvs=4"
  //       target="_blank"
  //     >
  //       Interview tips
  //     </a>
  //   ),
  //   key: '0'
  // },
  // {
  //   type: 'divider'
  // },
  // {
  //   label: (
  //     <a
  //       style={{ fontSize: 24 }}
  //       href="https://applyin.notion.site/Terms-and-Privacy-Policy-cb65ca863e6e418cb2f1f728a852a26c"
  //       target="_blank"
  //     >
  //       Terms & privacy
  //     </a>
  //   ),
  //   key: '1'
  // },
  // {
  //   type: 'divider'
  // },
  // {
  //   label: (
  //     <a
  //       style={{ fontSize: 24 }}
  //       href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop"
  //       target="_blank"
  //     >
  //       Microphone help
  //     </a>
  //   ),
  //   key: '3'
  // }
  // ]

  return (
    <Layout className="basic-layout">
      <Layout.Header>
        <Row className="logo-container" style={{ width: '100%' }}>
          {/* <Dropdown menu={{ items }} trigger={['click']} className="menu-icon">
            <a onClick={(e) => e.preventDefault()} style={{ fontSize: 32 }}>
              <Space style={{ height: '100%', fontSize: 32 }}>
                <MenuOutlined />
              </Space>
            </a>
          </Dropdown> */}
          <img src={logo} className="logo" />
        </Row>
      </Layout.Header>
      <Layout.Content>
        <Helmet>
          <title>Ai-Interview Preparations</title>
          <meta
            name="description"
            property="og:description"
            content="Welcome to aiinterview! Enhance your interview skills using ChatGPT's AI technology. Experience unlimited mock interview questions and get personalized feedback. Start your journey today!"
          />
        </Helmet>
        <Col style={{ display: 'flex', flexDirection: 'column' }}>
          <Row className="home-content">
            <div className="left-content">
              <h1 className="quote">Interview practice made easy</h1>
              <h3>Your dedicated interview coach, by your side, anytime and anywhere</h3>
              <p>🚀 Create an account</p>
              <p>👨‍💻 Add your profile details</p>
              <p>💼 Start taking mock interviews</p>
              <a href="aiinterview/interview-type" className="try-btn">
                Try now &gt;
              </a>
            </div>
            <div className="right-content">
              <img src={LandingImg1} style={{ padding: 20, width: '110%', objectFit: 'fill' }} />
            </div>
          </Row>
          {/* <Col className="brands-container">
            <h1>Trusted by the best in business</h1>
            <p>Enabling world-class talent to excel through AI-driven interview preperation</p>
            <Row className="brands-logos-container">
              <img src={LandingLogo2} alt="Yale-University-700x233" className="brands-logos" />
              <img src={LandingLogo1} alt="google" className="brands-logos" />
              <img src={LandingLogo3} alt="stanford-university-logo" className="brands-logos" />
            </Row>
          </Col> */}
          {/* <Row style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <h3 style={{ color: '#187EC1', margin: 30 }}>OUR FEATURES</h3>
          </Row> */}
          {/* <Row className="feature-content">
            <Col className="left-content">
              <h1>🎯 Practice a Question</h1>
              <h3>Perfect your answers, one question at a time</h3>
              <Col>
                <p className='landingpage-sub-heading'>👆 1 Question at a Time</p>
                <p>Dive into our extensive question bank and choose a specific question that you want to practice</p>
              </Col>
              <Col>
                <p className='landingpage-sub-heading'>⚡ Instant Analysis</p>
                <p>Record your audio response. Our AI, evaluates your answer, providing you with immediate feedback</p>
              </Col>
            </Col>
            <Col className="right-content">
              <img src={LandingImg2} style={{ padding: 20, width: '100%' }} />
            </Col> */}
          {/* </Row> */}
          {/* <div style={{ height: 150, width: '100%' }} /> */}
          {/* <Row className="feature-content">
            <Col className="left-content">
              <h1>🚀 Mock Interview </h1>
              <h3>Experience the full interview, tailored to your desired role</h3>
              <Col>
                <p className='landingpage-sub-heading'>🛠️ Customised Setup</p>
                <p>
                  Input the job title and detailed job description to tailor the mock interview to the specific role
                  you're aiming for
                </p>
              </Col>
              <Col>
                <p className='landingpage-sub-heading'>🗨️ Comprehensive Feedback</p>
                <p>
                  Receive a breakdown of your performance, highlighting areas of strength and opportunities for
                  improvement
                </p>
              </Col>
            </Col>
            <Col className="right-content">
              <img src={LandingImg3} style={{ padding: 20, width: '100%' }} />
            </Col>
          </Row> */}
          {/* <Col className="landingpage-last-container">
            <h1> Start your interview prep with ApplyIn</h1>
            Master Your Interview, One Question at a Time
            <a href="/prep" className="try-btn">
              Start ApplyIn free &gt;
            </a>
          </Col> */}
        </Col>
      </Layout.Content>
      <Footer />
    </Layout>
  )
}

export default Home
